<template>
	<div class="Detail">
		<div class="detail-box">
			<div class="close">
				<van-icon name="clear" @click="returns" />
			</div>
			<img class="auto-img" :src="detailData.large_img" alt="">
		</div>
		<div class="detail-info">
			<div class="detail-name">
				<p class="dename">{{detailData.name}}</p>
				<p class="deenname">{{detailData.enname}}</p>
			</div>

			<div class="detail-select">
				<div class="detail-select-box">
					<div class="item-select clearfix" v-for="(item, index) in detailData.rules" :key="index">
						<div class="temperature fl">{{item.title}}</div>
						<div class="clearfix">
							<div class="fl select-tag" v-for="(v,i) in item.rules" :key="i" :class="{active: v.isActive }" @click="toggleRule(v, index)">{{v.title}}</div>
						</div>
					</div>
				</div>
			</div>


			<div class="de-decription">
				<div class="de-decription-box">
					<div class="desc-title">商品详情</div>
					<div class="desc-msg" v-for="(item,index) in detailData.desc" :key="index">
						{{item}}
					</div>

				</div>
			</div>


			<div class="stepper">
				<div class="stepper-box clearfix">
					<div class="stepper-price fl">
						￥{{detailData.price}}
					</div>
					<div class="stepper-control fr">
						<van-stepper color="#212572" v-model="count" theme="round" button-size="22" disable-input />
					</div>
				</div>
			</div>
		</div>

		<div class="footer">
			<van-goods-action>
				<van-goods-action-icon icon="shopping-cart" :badge="bagCount == 0 ? '' : bagCount" text="购物袋" @click='goShopbag' />
				<van-goods-action-icon icon="like" text="收藏" :color="isLike ? '#aa0000' : '#ddd'" @click="likeAndNotLike" />
				<van-goods-action-button color="#be99ff" type="warning" text="加入购物袋" @click="addShopbag" />
				<van-goods-action-button color="#212572" type="danger" text="立即购买" @click="buyNow" />
			</van-goods-action>
		</div>
	</div>
</template>

<script>
	import '../assets/less/detail.less'
	import {
		utils
	} from '../assets/js/utils'


	export default {
		data() {
			return {
				count: 1,
				pid: '',
				detailData: [],
				isLike: false,
				bagCount: 0
			};
		},

		created() {
			this.pid = this.$route.query.pid;
			this.getProductByPid();

			//查询商品收藏
			this.findLike();

			//查询购物袋商品数据
			this.findShopbag();
		},

		methods: {

			//根据商品pid获取商品数据
			getProductByPid() {
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				}),

				this.axios({
					method: 'GET',
					url: '/productDetail',
					//如果get请求，参数需要放在params,如果是post请求，参数需要放在data
					params: {
						appkey: this.appkey,
						pid: this.pid
					}
				}).then(result => {
					this.$toast.clear();
					// 
					if (result.data.code == 600) {

					//处理商品描述数据
					result.data.result[0].desc = result.data.result[0].desc.split(/\n/);

					//处理商品规格数据
					let ruleItem = ['tem', 'sugar', 'cream', 'milk'];
					let rulesData = [];
					ruleItem.map(v => {
						if (result.data.result[0][v] == '') {
							return;
						}
						let rule = {
							title: result.data.result[0][v + '_desc'],
							rules: []
						};

						let r = result.data.result[0][v].split('/');
						r.map((value, index) => {
							let o = {
								title: value,
								isActive: index == 0
							};
							rule.rules.push(o);
						})

						rulesData.push(rule);
					})

						result.data.result[0].rules = rulesData;

						this.detailData = result.data.result[0];
					}
				}).catch(err => {
					this.$toast.clear();
				})
			},


			//切换规格
			toggleRule(v, index) {
				if (v.isActive) {
					return;
				}
				let ruleData = this.detailData.rules[index].rules;
				for (let i = 0; i < ruleData.length; i++) {
					if (ruleData[i].isActive) {
						ruleData[i].isActive = false;
						break;
					}
				}

				v.isActive = true;

			},

			//查询商品是否被收藏
			findLike() {
				let tokenString = localStorage.getItem('RETK');
				if (!tokenString) {
					return;
				}

				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})

				this.axios({
					method: 'GET',
					url: '/findlike',
					params: {
						appkey: this.appkey,
						tokenString,
						pid: this.pid
					}
				}).then(result => {
					this.$toast.clear();
					if (result.data.code == 1000) {
						if (result.data.result.length == 1) {
							this.isLike = true;
						}
					}

				}).catch(err => {
					this.$toast.clear();
				})
			},

			//收藏	
			likeAndNotLike() {
				//获取token字符串
				let tokenString = localStorage.getItem('RETK');
				if (!tokenString) {
					this.$router.push({
						name: 'Login'
					});
					return;
				}

				let data = utils.queryString({
					appkey: this.appkey,
					tokenString,
					pid: this.pid
				})

				let url = this.isLike ? '/notlike' : '/like';

				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})

				this.axios({
					method: 'POST',
					url,
					data
				}).then(result => {
					this.$toast.clear();
					if (result.data.code == 700) {
						return this.$router.push({
							name: 'Login'
						});
					}
					this.$toast(result.data.msg);

					if (result.data.code == 800) {
						this.isLike = true;
					} else if (result.data.code == 900) {
						this.isLike = false;
					}

				}).catch(err => {
					this.$toast.clear();
				})
			},

			// 查询购物车
			findShopbag() {

				//获取token
				let tokenString = localStorage.getItem('RETK');
				if (!tokenString) {
					return;
				}

				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})

				this.axios({
					method: 'GET',
					url: '/findAllShopcart',
					params: {
						appkey: this.appkey,
						tokenString
					}
				}).then(result => {
					this.$toast.clear();
					if (result.data.code == 5000) {
						this.bagCount = result.data.result.length;
					} else {
						this.$toast(result.data.msg);
					}

				}).catch(err => {
					this.$toast.clear();
				})
			},
			// 加入购物袋
			addShopbag(isBuy) {
				//获取token字符串
				let tokenString = localStorage.getItem('RETK');
				if (!tokenString) {
					return this.$router.push({
						name: 'Login'
					});
				}

				//获取选择的规格
				let rules = this.detailData.rules

				let rule = [];

				rules.map(v => {
					for (let i = 0; i < v.rules.length; i++) {
						if (v.rules[i].isActive) {
							rule.push(v.rules[i].title);
							break;
						}
					}
				})


				//序列化参数
				let data = utils.queryString({
					appkey: this.appkey,
					tokenString,
					pid: this.pid,
					count: this.count,
					rule: rule.join('/')
				})


				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})

				this.axios({
					method: 'POST',
					url: '/addShopcart',
					data
				}).then(result => {
					this.$toast.clear();
					if (result.data.code == 3000) {
						if (result.data.status == 1) {
							//累加徽章,购物袋数据
							this.bagCount++;
						}
						if (isBuy === true) {
							//立即购买
							setTimeout(() => {
								this.$router.push({
									name: 'Order',
									query: {
										sids: result.data.sid
									}
								});
							}, 600)
						}
					}
				}).catch(err => {
					this.$toast.clear();
				})
			},

			// 立即购买
			buyNow() {
				this.addShopbag(true);
			},

			//返回上一级
			returns() {
				this.$router.go(-1);
			},

			//回到购物袋
			goShopbag() {
				this.$router.push({
					name: 'Shopbag'
				});
			}


		}
	}
</script>

<style>
</style>
